import React, { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import {
  searchValoracion,
  EditarValoracion,
  EliminarValoracion,
} from "../../utils/api";

import editbutton from "../../static/images/edit-button.svg";
import addbutton from "../../static/images/addbutton.png";
import deletebutton from "../../static/images/delete-button.png";

const Valoraciones = ({ company, reload, edit }) => {
  const [listRatings, setlistRatings] = useState([]);
  const [valSelected, setvalSelected] = useState("");
  const [flag, setflag] = useState(false);
  const [update, setupdate] = useState(false);

  useEffect(() => {
    getValoraciones();
  }, [flag]);

  const getValoraciones = () => {
    axios
      .get("company-ratings/list-ratings/" + company.companyProfileId)
      .then((result) => {
        setlistRatings(result.data);
        // setLoading(false);
      });
  };

  function GuardarValoracion(values, reset) {
    let valoracion = {
      ratingId: 0,
      companyId: company.companyProfileId,
      title: values.title,
      description: values.description,
    };

    axios.post("company-ratings/create", valoracion).then((result) => {
      if (result.status === 200) {
        toast.success("Se ha agregado exitosamente!", {
          duration: 6000,
        });
        $("#crear-editar-acercade-modal").modal("hide");
        reset();
        // reload();
        setflag(flag ? false : true);
      }
    });
  }

  const Validaciones = Yup.object().shape({
    title: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(32, "No puede tener mas de 32 caracteres"),
    description: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(1200, "No puede tener mas de 1200 caracteres"),
  });

  return (
    <Fragment>
      <div className="vacancy__description bordered-box">
        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#crear-editar-acercade-modal"
          data-title="Acerca de"
          onClick={() => setupdate(false)}
        >
          {edit && (
            <img src={addbutton} alt="Agregar" style={{ float: "right" }}></img>
          )}
        </a>
        <div className="bordered-box__header">
          <div className="bordered-box__header-title">Buenas Practicas</div>
         
        </div>
        {listRatings.map((item) => {
          return (
            <Fragment>
              <div
                className="bordered-box__body"
                style={{
                  borderBottom: "1px solid #D5D5D5",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1 0 50%" }}>
                  <div className="bordered-box__header-title">Título</div>
                  <p>{item.title}</p>
                  <div className="bordered-box__header-title">Descripción</div>
                  <p>{item.description}</p>
                </div>
                {edit ? (
                  <div style={{ flex: "1 0 20%" }}>
                    <img
                      src={editbutton}
                      alt="Editar valoracion"
                      style={{ float: "right" }}
                      data-bs-toggle="modal"
                      data-bs-target="#crear-editar-acercade-modal"
                      data-title="Editar"
                      onClick={() => {
                        setupdate(true);
                        searchValoracion(
                          item.ratingId,
                          listRatings,
                          setvalSelected
                        );
                      }}
                    ></img>
                    <img
                      src={deletebutton}
                      alt="Eliminar valoracion"
                      style={{
                        float: "right",
                        width: "54px",
                        marginTop: "13px",
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#elimnar-valoracion-modal"
                      data-title="Eliminar"
                      onClick={() =>
                        searchValoracion(
                          item.ratingId,
                          listRatings,
                          setvalSelected
                        )
                      }
                    ></img>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Fragment>
          );
        })}
      </div>

      <div
        id="crear-editar-acercade-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          id="editAcerca"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-0">
              <div className="modal-title">Buenas Practicas</div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <hr className="mb-5"></hr>

            <div className="form form--white ">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  ratingId: valSelected?.ratingId ?? 0,
                  title: valSelected?.title ?? "",
                  description: valSelected?.description ?? "",
                  companyId: valSelected?.companyId ?? 0,
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  update
                    ? EditarValoracion(values, resetForm, setflag, flag)
                    : GuardarValoracion(values, resetForm);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="div__wrapper">
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label>Título</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            type="text"
                            className="mt-0"
                            name="title"
                            required
                          ></Field>
                          {errors.title && touched.title && (
                            <span className="form__validation form__validation--error">
                              {errors.title}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label htmlFor="description">Descripción</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            className="mt-0"
                            as="textarea"
                            name="description"
                            id="description"
                            required
                          ></Field>
                          {errors.description && touched.description && (
                            <span className="form__validation form__validation--error">
                              {errors.description}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="row form__row">
                        <div className="modal-footer">
                          <button
                            // disabled={isSubmitting}
                            type="button"
                            data-bs-dismiss="modal"
                            className="btn btn--cancel btn__icon btn__icon--door"
                          >
                            Cancelar
                          </button>
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--purple btn__icon btn__icon--door"
                          >
                            {update ? "Actualizar" : "Guardar"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div
        id="elimnar-valoracion-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Eliminar Valoracion
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() =>
                        EliminarValoracion(valSelected?.ratingId, setflag, flag)
                      }
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Valoraciones;
